export default __webpack_public_path__ + "media/images/mailer/icon_cached-d82304cbd965343f5f6a5631d68e8a15.png";